import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { FieldPropsWithType } from "@/app/servers/types";

export const TimeoutField = ({ form, canUpdate, type }: FieldPropsWithType) => (
  <FormField
    control={form.control}
    name={`${type}.timeout`}
    render={({ field }) => (
      <FormItem>
        <FormLabel>Timeout</FormLabel>
        <FormControl>
          <Input
            {...field}
            disabled={!canUpdate}
            placeholder="30"
            type="number"
            // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
            value={field.value as number | undefined}
          />
        </FormControl>
        <FormDescription>
          Timeout for calling the server's tools (in seconds)
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
);
